import { Component, OnInit } from "@angular/core";
import { SharedTranslateModule } from "../../utils/sharedTranslateModule";
import { SessionTimeoutComponent } from "../sessionTimeout/sessionTimeout.component";
import { Router } from "@angular/router";
import { RegistrationPopupComponent } from "../registrationPopup/registrationPopup.component";
import { MatDialog } from "@angular/material/dialog";



@Component({
    selector: "div.dtf-sitemap",
    imports: [SharedTranslateModule, SessionTimeoutComponent],
    templateUrl: "./sitemap.component.html",
    providers: [
    //  ClassesUtil, WindowRef
    ]
})
export class SiteMapComponent {

  constructor(
    private router: Router, private dialog: MatDialog
  ) { }

  sitemapSections = [
    {
      title: 'Home',
      links: [
        {
          label: 'Home',
          url: '/home'
        }
      ]
    },

    {
      title: 'Account',
      links: [
        {
          label: 'Guest Pay',
          url: '/home/guestpay'
        },
        {
          label: 'Register',
          action: 'register'
        },
        {
          label: 'Login',
          action: 'login'
        }
      ]
    },

    {
      title: 'Products & Solutions',
      links: [
        {
          label: 'Finance & Lease Solutions',
          url: '/home/financeleasesolutions'
        },
        {
          label: 'Dynamic Financing',
          url: '/home/dynamicfinancing'
        },
        {
          label: 'Electric Vehicle Solutions',
          url: '/home/electricFMV'
        },
        {
          label: 'Fair Market Value (FMV) Lease',
          url: '/home/electricFMV'
        },
        {
          label: 'Insurance',
          url: '/home/insurance'
        },
        {
          label: 'Connected Insurance',
          url: '/home/connected-insurance'
        },
        {
          label: 'GAP & GAP+',
          url: '/home/insurance'
        },
        {
          label: 'Vehicle Return Plan (VRP)',
          url: '/home/insurance'
        }
      ]
    },

    {
      title: 'Brochures',
      links: [
        {
          label: 'Brochures',
          url: '/home/brochures'
        }
      ]
    },

    {
      title: 'Truck Financing Brochures',
      links: [
        {
          label: 'Your Guide to Financing',
          url: '/static/assets/pdf/DTF_YGTF_Brochure_Updated_Oct22_Digital.pdf',
          external: true
        },
        {
          label: 'Finance & Lease Products',
          url: 'static/assets/pdf/DTF_Financing-LeaseProducts_Brochure_FINAL_Pages_lo.pdf',
          external: true
        },
        {
          label: 'Financing for Vocational Trucks',
          url: 'static/assets/pdf/DTF_FinancingForVocationalTrucks_Brochure_Updated_Oct22_Digital.pdf',
          external: true
        },
        {
          label: 'Financing for Municipalities',
          url: 'static/assets/pdf/DTF_FinancingForMuni_Brochure_Update_Oct22_Digital.pdf',
          external: true
        },
        {
          label: 'Your Guide to Dynamic Financing',
          url: 'static/assets/pdf/DTF_DynamicFinancing_Brochure_LoRes.pdf',
          external: true
        }
      ]
    },

    {
      title: 'Bus Financing Brochures',
      links: [
        {
          label: 'Your Guide to Bus Financing',
          url: 'static/assets/pdf/DTF_YGTBF_CAN_EN_Brochure_v4_080123sm.pdf',
          external: true
        },
        {
          label: 'School Bus Financing for Municipalities',
          url: 'static/assets/pdf/DTF_SBFinancingMuni_Brochure_FINAL_Pages_lo.pdf',
          external: true
        },
        {
          label: 'Your Guide to Electric Bus Financing',
          url: 'static/assets/pdf/DTF_JouleyBus_Brochure_FINAL_Pages_Digital.pdf',
          external: true
        }
      ]
    },

    {
      title: 'Insurance & Protection Products',
      links: [
        {
          label: 'Guaranteed Asset Protection (GAP & GAP+)',
          url: 'static/assets/pdf/DTF_GAP_Brochure_031124_digital.pdf',
          external: true
        },
        {
          label: 'Physical Damage & Non-Trucking Liability',
          url: 'static/assets/pdf/DTF_NTL-PDI_Brochure_031124_digital.pdf',
          external: true
        }
      ]
    },

    {
      title: 'Resources',
      links: [
        {
          label: 'Affordability & Payment Calculators',
          url: '/home/calculator'
        },
        {
          label: 'Pay by Credit Card with REPAY',
          url: 'https://dtf.repay.io/portal#/'
        },
        {
          label: 'Customer Payment Options',
          url: '/home/paymentoptions'
        },
        {
          label: 'Glossary of Terms',
          url: '/home/glossary'
        },
        {
          label: 'Frequently Asked Questions',
          url: '/home/faq'
        },
        {
          label: 'Dealer Locator',
          url: '/home/dealerlocator'
        }
      ]
    },

    {
      title: 'About DTFS',
      links: [
        {
          label: 'About Us',
          url: '/home/aboutus'
        },
        {
          label: 'DTFS Canada',
          url: '/ca/en/home'
        },
        {
          label: 'Press Releases',
          url: 'https://northamerica.daimlertruck.com/news-stories',
          external: true
        },
        {
          label: 'Careers',
          url: '/home/career'
        },
        {
          label: 'Agency Recruiters',
          url: 'https://my.recruitifi.com/app/public/agency-registration?solicited_employer=eb15eef3-98d8-4ff3-b9db-eef960f032ac',
          external: true
        }
      ]
    },

    {
      title: 'Support',
      links: [
        {
          label: 'Contact Us',
          url: '/home/contactus'
        }
      ]
    },

    {
      title: 'Legal',
      links: [
        {
          label: 'Privacy Policy & Terms of Use',
          url: '/home/useAndPrivacy'
        }
      ]
    }
  ];

  handleAction(action: string): void {
    sessionStorage.setItem('openDialog', action);
    window.location.href = '/home';
  }

}
